import React from "react";
import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

const Layout = () => (
  <>
    <Header />
    <main className="min-h-[60vh]">
      <Outlet />
    </main>
    <Footer />
    <WhatsAppFloat />
  </>
);

export default Layout;
